import {
  Box,
  Tab as MuiTab,
  styled,
  tabClasses,
  type TabProps as MuiTabProps,
  type BoxProps,
} from '@mui/material';
import { Chip, ChipProps } from 'components/chip';

export type TabProps = Omit<MuiTabProps, 'children'> & {
  children?: React.ReactNode;
  count?: React.ReactNode | number;
  renderCount?: (count?: TabProps['count']) => React.ReactNode;
  labelRootProps?: Omit<BoxProps, 'children'>;
  countBadgeProps?: Omit<ChipProps, 'label'>;
};

export const Tab = ({
  children,
  count,
  labelRootProps,
  countBadgeProps,
  renderCount,
  ...restProps
}: TabProps) => {
  return (
    <StyledTab
      id={`tab-${restProps?.value}`}
      aria-controls={`tabpanel-${restProps?.value}`}
      {...restProps}
      label={
        <Box
          {...labelRootProps}
          sx={[
            {
              display: 'flex',
              gap: '8px',
              alignItems: 'center',
            },
            ...(Array.isArray(labelRootProps?.sx) ? labelRootProps.sx : [labelRootProps?.sx]),
          ]}
        >
          {children || restProps?.label}{' '}
          {renderCount ? (
            renderCount(count)
          ) : (
            <Chip
              isBackgroundFilled
              size="sm"
              isTooltip={false}
              color="grey"
              label={count}
              {...countBadgeProps}
            />
          )}
        </Box>
      }
    />
  );
};

const StyledTab = styled((props: MuiTabProps) => <MuiTab {...props} />)(({ theme }) => ({
  fontWeight: 600,
  fontSize: theme.typography.smallTitle.fontSize,
  lineHeight: theme.typography.smallTitle.lineHeight,
  fontFamily: theme.typography.fontFamily,
  fontStyle: 'normal',
  color: theme.palette.text.secondary,
  textTransform: 'none',
  padding: '16px 24px',
  [`& .${tabClasses.selected}`]: {
    color: theme.palette.text.brandSecondary,
  },
}));
